import HBIcon from "@/components/HBIcon";
import { Dropdown } from "antd";
import classNames from "classnames";
import { useCallback, useMemo } from "react";
import { Else, If, Then, When } from "react-if";
import styles from "./index.module.less";

/**
 *  @param {*} props
 */

export default function HBSelect({
  value = null,
  name = "",
  iconType = "iconfont", // iconfont文字、img图片
  optionType = "text", // text文字、img图片
  optionKey = "value",
  options = [],
  placement = "bottomRight",
  trigger = "click",
  onChange = null,
  disabled,
  customprops = {},
  getPopupContainer = null,
  active = false,
  id = "",
}) {
  const onOptionClick = useCallback(
    (option) => () => {
      onChange && onChange(option);
    },
    [onChange]
  );

  // 渲染下拉菜单
  const menuList = useMemo(() => {
    return (
      <div className={styles.container}>
        <If condition={optionType === "text"}>
          <Then>
            <div className={styles.list}>
              <div className={styles.wrapper}>
                {options.map((option, index) => (
                  <Option
                    key={option[optionKey] || index}
                    option={option}
                    value={value}
                    name={name}
                    iconType={iconType}
                    onOptionClick={onOptionClick}
                  />
                ))}
              </div>
            </div>
          </Then>
          <Else>
            <div className={styles.imgs}>
              {options.map((option) => (
                <div
                  className={styles.img}
                  key={option[optionKey]}
                  onClick={onOptionClick(option)}
                  data-gd-click="button_click"
                  data-button-name={`筛选项${name ? `-${name}` : ""}-${
                    option.label
                  }`}
                >
                  <img src={option.icon} alt={option.label} />
                </div>
              ))}
            </div>
          </Else>
        </If>
      </div>
    );
  }, [optionType, options, optionKey, value, onOptionClick, name, iconType]);

  return (
    <Dropdown
      overlay={menuList}
      placement={placement}
      trigger={trigger}
      getPopupContainer={
        getPopupContainer || ((triggerNode) => triggerNode.parentNode)
      }
      disabled={disabled}
      {...customprops}
    >
      <div className={styles.select} id={id}>
        <div
          className={classNames([
            styles.trigger,
            active ? styles.active : null,
          ])}
          data-gd-click="button_click"
          data-button-name="筛选项"
        >
          <HBIcon type="a-hb_filter2" />
        </div>
      </div>
    </Dropdown>
  );
}

function Option({ option, value, name, iconType, onOptionClick }) {
  if (option.type === "label") {
    return (
      <div key={option.key} className={styles.label}>
        {option.label}
      </div>
    );
  }

  return (
    <div
      className={classNames([
        styles.item,
        option.value === value?.value ? styles.active : null,
      ])}
      onClick={onOptionClick(option)}
      data-gd-click="button_click"
      data-button-name={`筛选项${name ? `-${name}` : ""}-${option.label}`}
    >
      <When condition={option.icon}>
        <div className={styles.icon}>
          <If condition={iconType === "iconfont"}>
            <Then>
              <HBIcon className={styles.iconfont} type={option.icon} />
            </Then>
            <Else>
              <img src={option.icon} alt={option.label} />
            </Else>
          </If>
        </div>
      </When>
      <div className={styles.text}>{option.optionLabel || option.label}</div>
      <div className={styles.checked}>
        <HBIcon type="ic_check" />
      </div>
    </div>
  );
}
